'use client';
import React from 'react';

import WishlistRow from './WishlistRow';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import axios from '@/lib/axios';
import { toast } from 'react-toastify';
import { useAuth } from '@/features/authentication/hooks/auth';
const WishlistTable = () => {
  const { user } = useAuth();
  const { data, mutate } = useFetcherCSR(user && `/api/v2/wishlists`);

  const removeProduct = async (id: any) => {
    try {
      const res = await axios.get(
        `/api/v2/wishlists-remove-product?product_id=${id}`
      );

      if (res.status === 200) {
        toast.info(res?.data?.message);
        mutate();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="cart__product">
      {data?.data?.length > 0 ? (
        data?.data?.map((item: any, i: any) => (
          <WishlistRow removeProduct={removeProduct} key={i} product={item} />
        ))
      ) : (
        <div className="text-center text-muted py-5 border rounded">
          Your wishlist is empty
        </div>
      )}
    </div>
  );
};

export default WishlistTable;
